import {useContext} from 'react';
import {storeContext} from '../storage';

export const useStorageUserConfigContext = () => useContext(storeContext);
